import { configure, defineRule } from 'vee-validate'
import * as VeeRules from '@vee-validate/rules/'

import { localize, setLocale } from '@vee-validate/i18n'
import pt_BR from '@vee-validate/i18n/dist/locale/pt_BR.json'

let rules = VeeRules

try {
    Object.keys(rules).forEach(rule => {
        defineRule(rule, rules[rule])
    })
} catch (e) {
    try {
        rules = VeeRules.default

        Object.keys(rules).forEach(rule => {
            defineRule(rule, rules[rule])
        })
    } catch (e) {
        console.error("Error in define rules :: VeeValidate")
    }
}


configure({
    generateMessage: localize({
        pt_BR,
    }),
})

setLocale('pt_BR')

const templateFooterEmojiPattern = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/u

defineRule('template_footer', (value) => {
    if (!value) {
        return true
    }

    if (/\r|\n/.test(value) || templateFooterEmojiPattern.test(value)) {
        return 'O rodapé não pode ter novas linhas ou emojis.'
    }

    return true
})
